import { ReactNode, useState } from "react";
import { Button, Collapse } from "@mui/material";
import { MdLightbulbOutline } from "react-icons/md";

interface PageGuideProps {
  // Уникальный ключ подсказки: по нему запоминаем, свернул ли её пользователь
  id: string;
  title: string;
  children: ReactNode;
  className?: string;
}

const storageKey = (id: string) => `guide:${id}:collapsed`;

/**
 * Подсказка «Как это работает» вверху страницы.
 * Открыта по умолчанию; если пользователь её свернул — запоминаем в localStorage.
 */
export const PageGuide = ({ id, title, children, className = "" }: PageGuideProps) => {
  const [open, setOpen] = useState(() => localStorage.getItem(storageKey(id)) !== "1");

  const toggle = () => {
    const next = !open;
    setOpen(next);
    localStorage.setItem(storageKey(id), next ? "0" : "1");
  };

  return (
    <div className={`rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 mb-6 ${className}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-medium text-blue-900">
          <MdLightbulbOutline size={20} />
          {title}
        </div>
        <Button size="small" onClick={toggle}>
          {open ? "Скрыть" : "Показать"}
        </Button>
      </div>
      <Collapse in={open}>
        <div className="page-guide__content text-sm text-gray-700 mt-2 leading-relaxed">{children}</div>
      </Collapse>
    </div>
  );
};

export default PageGuide;
